import { Link } from "react-router-dom";
import Logo from "../../../images/logo.png"

const FooterLogo = () => {
    return (
        <div className="widget">
            <div className="footer-logo">
                <Link to="/"><img src={Logo} alt="흑우촌 로고"/></Link>
            </div>
        </div>
    )
}

export default FooterLogo;